import { isPublicExamHost } from './routes';

const DEFAULT_SITE_TITLE = '草莓创新管理平台';
const DEFAULT_PUBLIC_EXAM_TITLE = '在线考试';

const normalizeHostname = (value?: string) =>
  value
    ?.trim()
    .replace(/^https?:\/\//i, '')
    .replace(/\/.*$/, '')
    .toLowerCase() ?? '';

const DOMAIN_TITLE_MAP_ENTRIES = DOMAIN_TITLE_MAP.split(';')
  .map((item) => item.trim())
  .filter(Boolean)
  .map((item) => {
    const separatorIndex = item.indexOf('=');
    if (separatorIndex < 0) {
      return undefined;
    }
    const hostname = normalizeHostname(item.slice(0, separatorIndex));
    const title = item.slice(separatorIndex + 1).trim();
    if (!hostname || !title) {
      return undefined;
    }
    return [hostname, title] as const;
  })
  .filter((item): item is readonly [string, string] => Boolean(item));

const DOMAIN_TITLE_MAP_LOOKUP = new Map(DOMAIN_TITLE_MAP_ENTRIES);

export const getSiteTitleByHostname = (hostname?: string) => {
  const normalizedHostname = normalizeHostname(hostname);
  if (!normalizedHostname) {
    return DEFAULT_SITE_TITLE;
  }
  const configuredTitle = DOMAIN_TITLE_MAP_LOOKUP.get(normalizedHostname);
  if (configuredTitle) {
    return configuredTitle;
  }
  if (isPublicExamHost(normalizedHostname)) {
    return DEFAULT_PUBLIC_EXAM_TITLE;
  }
  return DEFAULT_SITE_TITLE;
};

export const getCurrentSiteTitle = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_SITE_TITLE;
  }
  return getSiteTitleByHostname(window.location.hostname);
};

export const syncDocumentSiteTitle = () => {
  if (typeof document === 'undefined') {
    return;
  }
  document.title = getCurrentSiteTitle();
};
